

















































import Vue from 'vue'
import resetForm from '@morpheus/utils/admin-vue/helpers/resetForm'
import { CodesExportData } from '../../types'
import AppDialogPrompt from '@morpheus/utils/admin-vue/components/AppDialogPrompt.vue'

export default Vue.extend({
  name: 'CodesExportForm',
  components: {
    AppDialogPrompt
  },
  props: {
    generatorId: {
      required: true,
      type: String
    },
    formId: {
      required: true,
      type: String
    },
    btnLabel: {
      required: false,
      type: String,
      default: 'Submit'
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        quantity: '',
        comment: ''
      },
      showDialog: false
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clear()
      }
    }
  },
  methods: {
    openDialog () {
      this.$validator.validateAll()
        .then((result: any) => {
          if (result) {
            this.showDialog = true
          }
        })
    },
    cancelExport () {
      this.showDialog = false
      this.form.comment = ''
    },
    confirmExport (comment: string) {
      this.form.comment = comment
      this.showDialog = false
      this.submit()
    },
    submit () {
      const param: CodesExportData = {
        id: this.generatorId,
        quantity: Number(this.form.quantity),
      }
      if(this.form.comment) {
        param.comment = this.form.comment
      }
      this.$emit('onSubmit', param)
      this.showDialog = false
    },
    clear () {
      resetForm(this.form)
      this.$validator.reset()
      this.$emit('onClearForm')
    }
  }
})
